import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { FileDown, ShieldCheck } from "lucide-react";
import { fdate, LEGAL_SHORT } from "./LegalTabs";

const API = process.env.REACT_APP_BACKEND_URL;

/** « Mes attestations » : PDF horodatés des acceptations de l'utilisateur connecté. */
export function LegalAttestations({ refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/legal/acceptances").then((r) => setItems(r.data || [])).catch(() => setItems([])); }, [refreshKey]);
  if (!items?.length) return null;
  return (
    <div className="bg-white border border-[#DEE2E6]" data-testid="legal-attestations">
      <div className="px-5 py-3 border-b border-[#DEE2E6] bg-[#F8F9FA] flex items-center gap-2 text-xs font-bold uppercase tracking-wider"><ShieldCheck className="h-4 w-4 text-[#059669]" />Mes attestations d'acceptation</div>
      <div className="divide-y divide-[#DEE2E6]">
        {items.map((a) => (
          <div key={a.id} className="px-5 py-3 flex flex-wrap items-center gap-3 text-xs" data-testid={`legal-attestation-${a.doc_key}-${a.version}`}>
            <span className="font-semibold">{a.doc_title || LEGAL_SHORT[a.doc_key] || a.doc_key} — v{a.version}</span>
            <span className="text-[#868E96]">acceptées le {fdate(a.accepted_at)}{a.attestation_no ? ` · n° ${a.attestation_no}` : ""}</span>
            <span className="flex-1" />
            <a href={`${API}/api/legal/acceptances/${a.id}/pdf`} target="_blank" rel="noreferrer" data-testid={`legal-attestation-pdf-${a.id}`} className="inline-flex items-center gap-1 font-semibold border border-[#0A0A0A] px-2 py-1 hover:bg-[#0A0A0A] hover:text-white"><FileDown className="h-3.5 w-3.5" />PDF</a>
          </div>
        ))}
      </div>
      <div className="px-5 py-2 text-[10px] text-[#868E96]">Chaque attestation est aussi archivée dans vos Documents RH.</div>
    </div>
  );
}
